import React, { useEffect, useState } from 'react';
import { reportButtonStyle } from '../../shared/ReportShell';
import { usePackingStation } from './packingStation';
import { knownDpi } from './zebraBrowserPrint';
import '../../shared/StyledInput.css';

// The size a label preview is showing: the tenant's default Label Size once
// it's known, until staff choose another. The preview shows the label at the
// resolution of the printer linked to that size, as far as this PC knows it,
// else 203 dpi.
export function useLabelSize(defaultSize) {
  const [sizeId, setSizeId] = useState(null);
  const { sizes, printerFor } = usePackingStation();
  const defaultId = defaultSize?.id || null;

  useEffect(() => { setSizeId(defaultId); }, [defaultId]);

  const size = sizes.find((s) => String(s.id) === String(sizeId))
    || (defaultSize && String(defaultSize.id) === String(sizeId) ? defaultSize : null)
    || sizes[0]
    || null;
  return {
    size,
    setSizeId,
    choices: sizes.length ? sizes : (defaultSize ? [defaultSize] : []),
    dpi: (size && knownDpi(printerFor(size.id))) || 203,
  };
}

// Small labels show bigger than life so they can be read on screen.
export const previewScale = (size) => (size ? Math.min(2, Math.max(1, 80 / Number(size.width_mm))) : 1);

// A label preview's heading, size choice and Print and Close, with what the
// preview says around the label itself (children).
function LabelPreviewFrame({ title, subtitle, sizing, onSize, onPrint, canPrint, printing, onClose, children }) {
  const { size, choices } = sizing;
  return (
    <div style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 14, marginBottom: 16, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>{title}</div>
          {subtitle && <div style={{ fontSize: 13, color: '#666' }}>{subtitle}</div>}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          {choices.length > 0 && (
            <select
              className="styled-input"
              value={size ? String(size.id) : ''}
              onChange={(e) => onSize(e.target.value)}
              title="Label size"
              style={{ width: 170 }}
            >
              {choices.map((s) => <option key={s.id} value={String(s.id)}>{s.name}</option>)}
            </select>
          )}
          <button type="button" onClick={onPrint} disabled={!canPrint} style={reportButtonStyle(!canPrint)}>
            {printing ? 'Printing...' : 'Print'}
          </button>
          <button type="button" onClick={onClose} style={reportButtonStyle(false)}>Close</button>
        </div>
      </div>
      {children}
    </div>
  );
}

export default LabelPreviewFrame;
